import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useToast,
  Heading,
  VStack,
  Flex,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useAdmin } from "../../context/AdminContext";
import { useTranslation } from "react-i18next";

export default function AdminNewsForm() {
  const colors = {
    teal: "#1da179",
    tealLight: "#34c49b",
  };

  const { id } = useParams();
  const isEdit = !!id;
  const { register, handleSubmit, reset, setValue } = useForm();
  const toast = useToast();
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  useEffect(() => {
    if (!isAdmin) {
      navigate("/admin/login");
    }
  }, [isAdmin, navigate]);

  const onSubmit = async (data) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Token missing");

      const formData = new FormData();
      formData.append("title", data.title);
      formData.append("shortDescription", data.shortDescription);
      formData.append("content", data.content);

      if (data.imageFile && data.imageFile.length > 0) {
        formData.append("image", data.imageFile[0]);
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      if (isEdit) {
        await axios.put(`https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/news/${id}`, formData, config);
        toast({ title: isArabic ? "تم التحديث" : "Updated", status: "success" });
      } else {
        await axios.post(`https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/news`, formData, config);
        toast({ title: isArabic ? "تم الإنشاء" : "Created", status: "success" });
      }

      navigate("/admin");
    } catch (err) {
      console.error(err);
      toast({
        title: isArabic ? "فشل العملية" : "Operation Failed",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (isEdit) {
      axios.get(`https://actpolymers-spring-26d90d713ec5.herokuapp.com/api/news/${id}`).then((res) => {
        const { title, shortDescription, content } = res.data;
        setValue("title", title);
        setValue("shortDescription", shortDescription);
        setValue("content", content);
      });
    }
  }, [id, setValue, isEdit]);

  return (
    <Flex
      justify="center"
      align="center"
      minH="100vh"
      bg="gray.50"
      px={6}
      py={16}
    >
      <Box
        w="full"
        maxW="700px"
        bg="white"
        p={{ base: 6, md: 10 }}
        borderRadius="2xl"
        boxShadow="2xl"
        textAlign={isArabic ? "right" : "left"}
      >
        <Heading
          size="lg"
          mb={8}
          color={colors.teal}
          textAlign="center"
          fontWeight="bold"
        >
          {isEdit
            ? isArabic
              ? "تحديث الخبر"
              : "Update News"
            : isArabic
            ? "إنشاء خبر جديد"
            : "Create News"}
        </Heading>

        <form onSubmit={handleSubmit(onSubmit)}>
          <VStack spacing={6}>
            <FormControl>
              <FormLabel>{isArabic ? "العنوان" : "Title"}</FormLabel>
              <Input {...register("title", { required: true })} />
            </FormControl>

            <FormControl>
              <FormLabel>{isArabic ? "الوصف القصير" : "Short Description"}</FormLabel>
              <Textarea {...register("shortDescription", { required: true })} />
            </FormControl>

            <FormControl>
              <FormLabel>{isArabic ? "المحتوى الكامل" : "Full Content"}</FormLabel>
              <Textarea {...register("content", { required: true })} rows={6} />
            </FormControl>

            <FormControl>
              <FormLabel>{isArabic ? "الصورة" : "Image"}</FormLabel>
              <Input
                type="file"
                accept="image/*"
                {...register("imageFile")}
              />
            </FormControl>

            <Button
              type="submit"
              bg={colors.teal}
              color="white"
              _hover={{ bg: colors.tealLight }}
              w="full"
              size="lg"
              fontWeight="bold"
            >
              {isEdit ? (isArabic ? "تحديث" : "Update") : (isArabic ? "إنشاء" : "Create")}
            </Button>
          </VStack>
        </form>
      </Box>
    </Flex>
  );
}
